import { ReactElement } from 'react';
import { Link as RSLink } from 'react-scroll';

import { useTheme, useMediaQuery, Stack, Link as MUILink } from '@mui/material';

import Logo from './components/Logo';
import Menu from './components/Menu';
import NavItem from './components/NavItem';
import User from './components/User';
import navItems from './data';
import { NavigationProps } from './types';

export default function Navigation({ invert }: NavigationProps): ReactElement {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));
  const isSm = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Stack
      direction='row'
      justifyContent='space-between'
      alignItems='stretch'
      flexWrap='nowrap'
      sx={{
        width: '100%',

        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1000,

        backgroundColor: invert ? 'white' : 'transparent',
        borderBottomWidth: invert ? '2px' : '0px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'divider',

        px: isXs ? 2 : 4,
        py: 2
      }}>
      <Logo invert={invert} />

      <Stack direction='row' justifyContent='flex-end' alignItems='center' spacing={1}>
        {!isSm ? (
          navItems.map((navItem) =>
            navItem.href ? (
              <MUILink
                key={navItem.label}
                aria-label={`${navItem.label} nav-item`}
                href={navItem.href}
                underline='none'>
                <NavItem {...navItem} color={invert ? 'black' : 'default'} />
              </MUILink>
            ) : (
              <RSLink
                key={navItem.label}
                aria-label={`${navItem.label} nav-item`}
                to={navItem.to || ''}
                spy
                smooth
                offset={-99.19}>
                <NavItem {...navItem} color={invert ? 'black' : 'default'} />
              </RSLink>
            )
          )
        ) : (
          <Menu invert={invert} />
        )}
        <User invert={invert} />
      </Stack>
    </Stack>
  );
}
